import Binders from './binders';
import Loaders from './loaders';
import Renderers from './renderers';
import Updaters from './updaters';
import Utilities from './utilities';
import { showRecentlyViewed, saveRecentlyViewed } from '../recently_viewed_helpers';

const Initializers = {};

Initializers.initCampaign = () => {
  const designCampaign = new TeePublic.ProductPage.Designs.Campaigns();
  designCampaign.init();
};

Initializers.initExchangePage = () => {
  Object.keys(TeePublic.Exchange.Data).forEach((oliId) => {
    Binders.bindExchangeEvents(oliId);
    Renderers.renderExchangeOptionsOnInit(oliId);
  });
};

Initializers.initPage = (opts, defaultImgIndex) => {
  const { ProductOptions } = TeePublic;
  const {
    paths,
    similar_products_enabled,
    similar_products_personalized_enabled,
    trending_designs_personalized_enabled,
    recently_viewed_enabled,
    design_id,
    store_id,
    canvas_id,
  } = opts;
  const {
    similar_products_path,
    similar_products_personalized_path,
    trending_designs_personalized_path,
    recently_viewed_path,
  } = paths;

  const products = Utilities.sanitizeProducts(ProductOptions, true);
  const fragmentProduct = Utilities.getFragmentIdProduct(products);
  const gallery = TeePublic.ProductPage.PhotoGallery.init(defaultImgIndex);
  Renderers.renderOptionsOnInit(products);
  Renderers.renderSeasonalColorTipOnInit(products);

  // Always update the gallery on initial load because sometimes the default product is not available
  const initialProductId = fragmentProduct ? fragmentProduct.id : null;
  Updaters.updatePdpProductData(gallery, initialProductId);

  Binders.bindProductPageEvents(defaultImgIndex, store_id, design_id, gallery);

  if (similar_products_enabled) Loaders.loadSimilarProductImgs(similar_products_path);
  if (similar_products_personalized_enabled) Loaders.loadSimilarProductImgs(similar_products_personalized_path);
  if (trending_designs_personalized_enabled) Loaders.loadSimilarProductImgs(trending_designs_personalized_path);

  try {
    // Save this product to Recently Viewed
    saveRecentlyViewed(design_id, canvas_id, recently_viewed_enabled);
    // Do NOT include the current design being viewed in the recently viewed list
    showRecentlyViewed(design_id, canvas_id, recently_viewed_path, recently_viewed_enabled);
  } catch (error) {
    // See pattern from app/javascript/core/controllers/index.js,
    // which uses a Stimulus-specific error handling pattern.
    const { bugsnagClient } = window;
    if (!bugsnagClient) { return; }

    const message = 'Error saving or showing recently viewed designs';
    const context = { design_id: design_id, canvas_id: canvas_id, recently_viewed_enabled: recently_viewed_enabled };
    bugsnagClient.notify(error, (event) => {
      event.addMetadata('message', message);
      event.addMetadata('context', context);
    });
  }
};

export default Initializers;
